<template>
  <qrcode-vue :value="url" :level="level" :render-as="renderAs" :size="size" />
</template>

<script setup>
import QrcodeVue from "qrcode.vue";
defineProps({
  // 二维码的内容值
  url: String,
  // 定义空白区的宽度应该是多少 ('L' | 'M' | 'Q' | 'H')`
  level: {
    type: String,
    default: "M"
  },
  // 边距
  margin: {
    type: Number,
    default: 0
  },
  // 标签 ('svg'|'canvas')
  renderAs: {
    type: String,
    default: "svg"
  },
  // 二维码的大小
  size: {
    type: Number,
    default: 100
  },
  // 二维码背景颜色
  background: {
    type: String,
    default: "#ffffff"
  },
  // 二维码前景颜色。
  class: {
    type: String,
    default: ""
  }
});
</script>
